// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { DocumentEntity_EntityFragment, DocumentTestamentaryEntity_TestamentaryEntityFragment } from '../../graphql/DocumentFragment.generated';
import { gql } from '@apollo/client';
import { DocumentEntity_EntityFragmentDoc, DocumentTestamentaryEntity_TestamentaryEntityFragmentDoc } from '../../graphql/DocumentFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DocumentsTable_DocumentFragment = { __typename?: 'Document', id: string, createdAt: Time, displayType: string, name: string, type: Types.DocumentType, createdByUser: { __typename?: 'User', id: string, displayName: string }, summaries?: Array<{ __typename?: 'DocumentSummary', id: string, entryMode?: Types.DocumentSummaryEntryMode | null, updatedAt: Time, updateUser: { __typename?: 'User', id: string, displayName: string } }> | null, defaultDocumentOfEntity?: { __typename?: 'Entity', id: string } | null, additionalEntities?: Array<(
    { __typename?: 'Entity' }
    & DocumentEntity_EntityFragment
  )> | null, additionalTestamentaryEntities?: Array<(
    { __typename?: 'TestamentaryEntity' }
    & DocumentTestamentaryEntity_TestamentaryEntityFragment
  )> | null, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, entity?: (
          { __typename?: 'Entity' }
          & DocumentEntity_EntityFragment
        ) | null, testamentaryEntity?: (
          { __typename?: 'TestamentaryEntity' }
          & DocumentTestamentaryEntity_TestamentaryEntityFragment
        ) | null } | null } | null> | null }, lifetimeExclusionEvent?: Array<{ __typename?: 'LifetimeExclusionEvent', id: string, eventDate: Time, giftAmount?: CurrencyUSD | null, kind: Types.LifetimeExclusionEventKind, grantor: { __typename?: 'ClientProfile', id: string, displayName: string } }> | null, clientProfile?: { __typename?: 'ClientProfile', id: string, displayName: string } | null };

export type DocumentsTableDocumentsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DocumentWhereInput>;
  orderBy?: Types.InputMaybe<Array<Types.DocumentOrder> | Types.DocumentOrder>;
}>;


export type DocumentsTableDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: (
        { __typename?: 'Document' }
        & DocumentsTable_DocumentFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    DocumentsTableDocuments: 'DocumentsTableDocuments' as const
  },
  Fragment: {
    DocumentsTable_Document: 'DocumentsTable_Document' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DocumentsTable_DocumentFragmentDoc = gql`
    fragment DocumentsTable_Document on Document {
  id
  createdAt
  createdByUser: user {
    id
    displayName
  }
  displayType
  name
  type
  summaries {
    id
    entryMode
    updateUser {
      id
      displayName
    }
    updatedAt
  }
  defaultDocumentOfEntity {
    id
  }
  additionalEntities {
    ...DocumentEntity_Entity
  }
  additionalTestamentaryEntities {
    ...DocumentTestamentaryEntity_TestamentaryEntity
  }
  entityDocumentRelationships {
    edges {
      node {
        id
        relationshipType
        entity {
          ...DocumentEntity_Entity
        }
        testamentaryEntity {
          ...DocumentTestamentaryEntity_TestamentaryEntity
        }
      }
    }
  }
  lifetimeExclusionEvent {
    id
    eventDate
    grantor {
      id
      displayName
    }
    giftAmount
    kind
  }
  clientProfile {
    id
    displayName
  }
}
    ${DocumentEntity_EntityFragmentDoc}
${DocumentTestamentaryEntity_TestamentaryEntityFragmentDoc}`;
export const DocumentsTableDocumentsDocument = gql`
    query DocumentsTableDocuments($where: DocumentWhereInput, $orderBy: [DocumentOrder!]) {
  documents(where: $where, orderBy: $orderBy) {
    edges {
      node {
        ...DocumentsTable_Document
      }
    }
  }
}
    ${DocumentsTable_DocumentFragmentDoc}`;

/**
 * __useDocumentsTableDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsTableDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsTableDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsTableDocumentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDocumentsTableDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentsTableDocumentsQuery, DocumentsTableDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsTableDocumentsQuery, DocumentsTableDocumentsQueryVariables>(DocumentsTableDocumentsDocument, withFetchPolicyContext(options));
      }
export function useDocumentsTableDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsTableDocumentsQuery, DocumentsTableDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsTableDocumentsQuery, DocumentsTableDocumentsQueryVariables>(DocumentsTableDocumentsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDocumentsTableDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentsTableDocumentsQuery, DocumentsTableDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentsTableDocumentsQuery, DocumentsTableDocumentsQueryVariables>(DocumentsTableDocumentsDocument, withFetchPolicyContext(options));
        }
export type DocumentsTableDocumentsQueryHookResult = ReturnType<typeof useDocumentsTableDocumentsQuery>;
export type DocumentsTableDocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsTableDocumentsLazyQuery>;
export type DocumentsTableDocumentsSuspenseQueryHookResult = ReturnType<typeof useDocumentsTableDocumentsSuspenseQuery>;
export type DocumentsTableDocumentsQueryResult = Apollo.QueryResult<DocumentsTableDocumentsQuery, DocumentsTableDocumentsQueryVariables>;